<template>
	<Toaster />
	<n-notification-provider placement="top">
		<n-config-provider
			:locale="locale"
			:date-locale="dateLocale"
			:abstract="true"
			:theme-overrides="themeOverrides"
		>
			<n-loading-bar-provider>
				<n-message-provider>
					<n-space vertical :class="darkTheme">
						<slot>
							<n-layout has-sider>
								<VNotification
									:status="connectionLost && isAuth"
									text="Нет соединения"
									:type="type.connection"
								>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<circle cx="8.99906" cy="8.99833" r="8.335" fill="#3D7AA5" />
										<path
											d="M9 4.19727V6.11769"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M9 11.8789V13.7993"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M5.60547 5.60388L6.96417 6.96258"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M11.0352 11.0339L12.3939 12.3926"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M4.19922 8.99829H6.11965"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M11.8789 8.99829H13.7993"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M5.60547 12.3926L6.96417 11.0339"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M11.0352 6.96258L12.3939 5.60388"
											stroke="white"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</VNotification>
								<VNotification
									v-if="createTaskId"
									:status="successCreate"
									:text="`Задача создана #${createTaskId}`"
									:type="type.link"
									:link="createTaskId"
									@hideNotification="hideNotificationCreate"
								>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M10.0007 1.66675C5.40934 1.66675 1.66797 5.40812 1.66797 9.99943C1.66797 14.5907 5.40934 18.3321 10.0007 18.3321C14.592 18.3321 18.3333 14.5907 18.3333 9.99943C18.3333 5.40812 14.592 1.66675 10.0007 1.66675ZM13.9837 8.08291L9.25904 12.8075C9.14238 12.9242 8.98406 12.9909 8.81741 12.9909C8.65076 12.9909 8.49244 12.9242 8.37578 12.8075L6.01763 10.4494C5.77598 10.2077 5.77598 9.80778 6.01763 9.56613C6.25928 9.32448 6.65924 9.32448 6.90089 9.56613L8.81741 11.4826L13.1004 7.19965C13.3421 6.958 13.742 6.958 13.9837 7.19965C14.2253 7.4413 14.2253 7.83293 13.9837 8.08291Z"
											fill="#00BB34"
										/>
									</svg>
								</VNotification>

								<SuccessNotification text="Логин успешный" :status="loginNotification" />

								<MobileMenu
									@reset-app="handleUpdateMenuValue"
									v-if="$route.name !== 'Login' && $route.name !== 'Mobile'"
								/>

								<sidebar
									v-if="
										isSidebarEnabled && appReady && isAuth && $route.name !== 'Login' && !isMobile
									"
									@reset-app="handleUpdateMenuValue"
								/>

								<n-layout :class="'app__class'">
									<router-view />
								</n-layout>
								<div class="overlay" v-if="!appReady">
									<season-animation />
									<svg
										class="first-load"
										width="598"
										height="194"
										viewBox="0 0 598 194"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M104.355 55.4472V8.13863C99.6807 7.38932 94.8859 7 90 7C87.2517 7 84.5321 7.12319 81.8465 7.36436L81.265 35.128C81.1014 42.9422 74.7199 49.1913 66.9041 49.1913H13.7342C5.03243 63.0435 0 79.4341 0 97C0 101.099 0.274041 105.134 0.804803 109.088H34.3562C37.579 109.088 40.1917 106.475 40.1917 103.253V90.2781C35.1802 88.4555 31.601 83.65 31.601 78.0086C31.601 70.8002 37.4446 64.9566 44.653 64.9566C51.8613 64.9566 57.7049 70.8002 57.7049 78.0086C57.7049 83.7968 53.9371 88.7049 48.7203 90.4143V103.253C48.7203 111.186 42.2893 117.617 34.3562 117.617H2.3724C4.08653 124.931 6.69266 131.901 10.0698 138.407H52.1061C60.0391 138.407 66.4702 144.838 66.4702 152.771V183.893C73.9705 185.919 81.8591 187 90 187C131.203 187 165.94 159.312 176.618 121.527H155.163C152.94 121.527 151.09 123.235 150.912 125.451L149.699 140.623C149.167 147.272 143.617 152.396 136.947 152.396H113.108C111.341 157.511 106.484 161.184 100.769 161.184C93.5602 161.184 87.7167 155.34 87.7167 148.132C87.7167 140.924 93.5602 135.08 100.769 135.08C106.484 135.08 111.341 138.753 113.108 143.868H136.947C139.17 143.868 141.02 142.159 141.197 139.943L142.411 124.771C142.943 118.122 148.493 112.998 155.163 112.998H178.582C179.514 107.806 180 102.46 180 97C180 94.8113 179.922 92.6409 179.768 90.4914H142.855C141.088 95.6059 136.231 99.2792 130.516 99.2792C123.308 99.2792 117.464 93.4357 117.464 86.2273C117.464 79.0189 123.308 73.1754 130.516 73.1754C136.231 73.1754 141.088 76.8484 142.855 81.9627H178.749C177.474 74.3783 175.249 67.1159 172.203 60.3017H150.038C142.105 60.3017 135.674 53.8707 135.674 45.9376V19.4344C128.636 15.2808 120.983 12.058 112.884 9.93514V55.4472C112.884 62.5126 107.156 68.2403 100.091 68.2403H93.1288C90.7737 68.2403 88.8645 70.1495 88.8645 72.5046V96.0173C94.3036 97.5918 98.2803 102.61 98.2803 108.556C98.2803 115.764 92.4368 121.608 85.2284 121.608C78.02 121.608 72.1765 115.764 72.1765 108.556C72.1765 103.078 75.5515 98.3878 80.3358 96.4521V72.5046C80.3358 65.4392 86.0634 59.7116 93.1288 59.7116H100.091C102.446 59.7116 104.355 57.8024 104.355 55.4472ZM73.2911 8.54811C51.791 12.5845 32.9869 24.2663 19.8097 40.6627H66.9041C70.0793 40.6627 72.6717 38.1239 72.7382 34.9494L73.2911 8.54811ZM144.203 25.1464V45.9376C144.203 49.1604 146.816 51.773 150.038 51.773H167.828C161.788 41.4019 153.735 32.3478 144.203 25.1464ZM57.9415 181.123C40.357 174.418 25.4161 162.357 15.1123 146.935H52.1061C55.3289 146.935 57.9415 149.548 57.9415 152.771V181.123ZM39.232 78.0086C39.232 75.0146 41.659 72.5876 44.653 72.5876C47.6469 72.5876 50.074 75.0146 50.074 78.0086C50.074 81.0025 47.6469 83.4296 44.653 83.4296C41.659 83.4296 39.232 81.0025 39.232 78.0086ZM79.8074 108.556C79.8074 105.562 82.2344 103.135 85.2284 103.135C88.2223 103.135 90.6494 105.562 90.6494 108.556C90.6494 111.55 88.2223 113.977 85.2284 113.977C82.2344 113.977 79.8074 111.55 79.8074 108.556ZM95.3476 148.132C95.3476 145.138 97.7747 142.711 100.769 142.711C103.763 142.711 106.19 145.138 106.19 148.132C106.19 151.126 103.763 153.553 100.769 153.553C97.7747 153.553 95.3476 151.126 95.3476 148.132ZM130.516 80.8063C127.522 80.8063 125.095 83.2333 125.095 86.2273C125.095 89.2212 127.522 91.6483 130.516 91.6483C133.51 91.6483 135.937 89.2212 135.937 86.2273C135.937 83.2333 133.51 80.8063 130.516 80.8063Z"
											fill="#3d7aa5"
										/>
										<path
											d="M241.211 145.281C237.605 145.281 234.852 144.285 232.954 142.292C231.056 140.299 230.107 137.499 230.107 133.893V54.8857C230.107 51.1844 231.056 48.3848 232.954 46.4867C234.947 44.5886 237.747 43.6396 241.353 43.6396H275.946C287.144 43.6396 295.78 46.3444 301.854 51.7539C307.928 57.1633 310.965 64.7082 310.965 74.3883C310.965 80.652 309.589 86.0614 306.837 90.6168C304.084 95.1722 300.099 98.6836 294.879 101.151C289.754 103.619 283.443 104.852 275.946 104.852L277.084 102.432H282.921C286.907 102.432 290.371 103.429 293.313 105.422C296.35 107.32 298.96 110.262 301.142 114.248L309.968 130.619C311.297 132.991 311.914 135.316 311.819 137.594C311.724 139.872 310.87 141.722 309.257 143.146C307.643 144.569 305.271 145.281 302.139 145.281C299.007 145.281 296.445 144.617 294.452 143.288C292.554 141.96 290.845 139.919 289.327 137.167L275.661 111.97C274.237 109.313 272.482 107.51 270.394 106.561C268.401 105.612 265.933 105.137 262.991 105.137H252.172V133.893C252.172 137.499 251.223 140.299 249.325 142.292C247.522 144.285 244.817 145.281 241.211 145.281ZM252.172 89.1933H271.96C277.844 89.1933 282.257 88.007 285.199 85.6344C288.236 83.2618 289.754 79.7029 289.754 74.9577C289.754 70.3075 288.236 66.796 285.199 64.4235C282.257 62.0509 277.844 60.8646 271.96 60.8646H252.172V89.1933ZM353.143 145.566C347.259 145.566 342.372 144.475 338.481 142.292C334.59 140.109 331.695 136.835 329.797 132.469C327.994 128.009 327.092 122.504 327.092 115.956V83.7838C327.092 80.1774 327.994 77.4727 329.797 75.6695C331.695 73.8664 334.352 72.9648 337.769 72.9648C341.185 72.9648 343.843 73.8664 345.741 75.6695C347.639 77.4727 348.588 80.1774 348.588 83.7838V116.525C348.588 120.701 349.442 123.833 351.15 125.921C352.859 127.914 355.563 128.91 359.265 128.91C363.345 128.91 366.667 127.487 369.229 124.64C371.887 121.698 373.215 117.854 373.215 113.109V83.7838C373.215 80.1774 374.117 77.4727 375.92 75.6695C377.818 73.8664 380.475 72.9648 383.892 72.9648C387.403 72.9648 390.061 73.8664 391.864 75.6695C393.762 77.4727 394.711 80.1774 394.711 83.7838V134.32C394.711 141.627 391.247 145.281 384.319 145.281C380.902 145.281 378.293 144.332 376.489 142.434C374.686 140.536 373.785 137.831 373.785 134.32V124.782L375.92 130.334C373.832 135.174 370.843 138.923 366.952 141.58C363.061 144.237 358.458 145.566 353.143 145.566ZM436.541 145.566C428.095 145.566 421.784 143.241 417.608 138.591C413.432 133.845 411.344 126.822 411.344 117.522V53.3198C411.344 49.7134 412.246 47.0087 414.049 45.2055C415.947 43.3074 418.652 42.3584 422.163 42.3584C425.58 42.3584 428.19 43.3074 429.993 45.2055C431.891 47.0087 432.84 49.7134 432.84 53.3198V116.668C432.84 120.559 433.647 123.453 435.26 125.351C436.968 127.155 439.198 128.056 441.951 128.056C442.71 128.056 443.422 128.009 444.086 127.914C444.75 127.819 445.462 127.772 446.221 127.772C447.74 127.582 448.784 128.056 449.353 129.195C450.017 130.239 450.35 132.374 450.35 135.601C450.35 138.448 449.78 140.631 448.641 142.149C447.502 143.573 445.747 144.522 443.374 144.996C442.425 145.091 441.334 145.186 440.1 145.281C438.866 145.471 437.68 145.566 436.541 145.566ZM484.817 145.566C480.642 145.566 476.323 145.186 471.863 144.427C467.497 143.668 463.511 142.387 459.905 140.583C458.007 139.634 456.631 138.448 455.777 137.025C455.018 135.506 454.685 133.988 454.78 132.469C454.875 130.951 455.35 129.575 456.204 128.341C457.153 127.107 458.339 126.301 459.763 125.921C461.281 125.446 462.942 125.589 464.745 126.348C468.636 127.961 472.195 129.1 475.422 129.764C478.649 130.429 481.828 130.761 484.96 130.761C489.041 130.761 491.983 130.144 493.786 128.91C495.684 127.582 496.633 125.873 496.633 123.786C496.633 121.887 496.016 120.464 494.782 119.515C493.548 118.566 491.745 117.902 489.373 117.522L474.425 114.817C468.541 113.773 463.986 111.638 460.759 108.411C457.627 105.09 456.062 100.866 456.062 95.7416C456.062 90.9964 457.39 86.9156 460.048 83.4991C462.705 79.9876 466.359 77.3303 471.009 75.5272C475.754 73.6291 481.116 72.6801 487.095 72.6801C491.366 72.6801 495.304 73.0597 498.91 73.8189C502.517 74.5781 505.981 75.8119 509.302 77.5201C511.011 78.3743 512.197 79.5131 512.861 80.9367C513.621 82.3602 513.858 83.8312 513.573 85.3497C513.383 86.8681 512.814 88.2442 511.865 89.478C510.916 90.7117 509.682 91.5184 508.164 91.898C506.74 92.2776 505.079 92.0878 503.181 91.3286C500.144 89.905 497.345 88.9085 494.782 88.3391C492.22 87.6748 489.752 87.3426 487.38 87.3426C483.109 87.3426 480.025 88.0544 478.127 89.478C476.229 90.8066 475.28 92.5149 475.28 94.6028C475.28 96.2161 475.801 97.5922 476.845 98.7311C477.984 99.775 479.693 100.487 481.97 100.866L496.918 103.571C503.086 104.615 507.784 106.703 511.011 109.835C514.237 112.872 515.851 117.047 515.851 122.362C515.851 129.575 513.004 135.269 507.309 139.445C501.71 143.525 494.213 145.566 484.817 145.566ZM564.421 145.566C556.164 145.566 549.046 144.095 543.067 141.153C537.183 138.116 532.628 133.893 529.401 128.483C526.269 122.979 524.703 116.525 524.703 109.123C524.703 101.91 526.222 95.5992 529.259 90.1897C532.296 84.6853 536.519 80.4147 541.928 77.3778C547.433 74.246 553.649 72.6801 560.577 72.6801C565.607 72.6801 570.162 73.5342 574.243 75.2425C578.324 76.8558 581.835 79.2284 584.777 82.3602C587.719 85.3971 589.95 89.1458 591.468 93.6063C592.986 97.9718 593.746 102.859 593.746 108.269C593.746 110.072 593.176 111.448 592.037 112.397C590.899 113.251 589.238 113.678 587.055 113.678H542.355V102.575H578.229L575.951 104.568C575.951 100.677 575.382 97.4499 574.243 94.8875C573.104 92.2302 571.443 90.2372 569.261 88.9085C567.173 87.5799 564.563 86.9156 561.431 86.9156C557.92 86.9156 554.93 87.7223 552.463 89.3356C549.995 90.949 548.097 93.2741 546.769 96.311C545.44 99.3479 544.776 103.002 544.776 107.272V108.411C544.776 115.624 546.436 120.938 549.758 124.355C553.174 127.772 558.204 129.48 564.848 129.48C567.125 129.48 569.735 129.195 572.677 128.626C575.619 128.056 578.371 127.155 580.934 125.921C583.117 124.877 585.062 124.545 586.77 124.924C588.479 125.209 589.807 125.968 590.756 127.202C591.705 128.436 592.227 129.859 592.322 131.473C592.512 133.086 592.18 134.699 591.326 136.313C590.472 137.831 589.048 139.112 587.055 140.156C583.828 141.96 580.175 143.288 576.094 144.142C572.108 145.091 568.217 145.566 564.421 145.566Z"
											fill="#3d7aa5"
										/>
									</svg>
								</div>
							</n-layout>
						</slot>
					</n-space>
				</n-message-provider>
			</n-loading-bar-provider>
		</n-config-provider>
	</n-notification-provider>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, onUnmounted, provide, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
	dateRuRU,
	NConfigProvider,
	NLayout,
	NLoadingBarProvider,
	NMessageProvider,
	NNotificationProvider,
	NSpace,
	ruRU,
} from "naive-ui";

import { menuThemeOverrides, themeOverrides } from "@/shared/assets/themeStyle";

import { getForms } from "./core/api/form_api";
import { getUnreadTaskCounter } from "./core/api/task_comments_api";
import { getUserInfoById, getUsersDepartments } from "./core/api/user_api";
import { getBotById, getUserById } from "./core/userInteraction";
import { DesktopVersion } from "./domain/basic";
import { SocketResponse, StoreNotification, TaskComment } from "./domain/task";
import { Bot, User } from "./domain/user";
import { getMenuOption } from "./helpers/sidebarOptions";

import MobileMenu from "@/components/ui/MobileMenu.vue";
import SuccessNotification from "@/components/ui/notification/SuccessNotification.vue";
import VNotification from "@/components/ui/notification/VNotification.vue";
import seasonAnimation from "@/components/ui/SeasonAnimation.vue";
import Sidebar from "@/components/ui/sidebar.vue";
import { notificationInjectKey, notificationStatus } from "@/core/const";
import { CurrentUser } from "@/core/store/globalStore";
import { getSettings, removeAnchorTags, removeSpanFromComment, removeUnnecessaryStringAt } from "@/core/utils";
import { CatalogDataTypeWithTime } from "@/domain/catalog";
import Toaster from "@/shared/ui/toast/Toaster.vue";
import * as Sentry from "@sentry/vue";

export default defineComponent({
	name: "App",
	components: {
		NConfigProvider,
		NLayout,
		NSpace,
		NMessageProvider,
		NLoadingBarProvider,
		NNotificationProvider,
		SuccessNotification,
		Sidebar,
		VNotification,
		seasonAnimation,
		MobileMenu,
		Toaster,
	},
	provide() {
		return {
			socketMessage: computed(() => this.socketMessage),
		};
	},
	setup() {
		const successCreate = ref<boolean>(false);
		const createTaskId = ref<null | number>(null);
		const store = useStore();
		const darkTheme = computed(() => store.getters.getTheme);
		const route = useRoute();
		const domain = import.meta.env.VITE_RADAR_SOCKET_URL;
		const socketMessage = ref<unknown>(null);
		const type = notificationStatus;
		const socketWorker = ref<SharedWorker | null>(null);
		const router = useRouter();
		const connectionLost = ref<boolean>(false);
		const isAuth = computed(() => store.getters.isAuth);
		const isSocketConnected = ref<boolean>(false);
		const chatSocket = ref<null | WebSocket>(null);
		const isMobile = computed<boolean>(() => store.getters.getIsMobile);
		const desktopVersion = computed<DesktopVersion>(() => store.getters.getDesktopVersion);

		const updateIsMobile = () => {
			store.commit("setIsMobile", window.innerWidth < 768);
		};

		const isMobileVersion = () => {
			return window.location.href.includes(`m.rulse.ru`);
		};

		watch(createTaskId, () => {
			if (createTaskId.value === null) return;
			successCreate.value = true;

			setTimeout(() => {
				successCreate.value = false;
				createTaskId.value = null;
			}, 6000);
		});

		watch(darkTheme, () => {
			document.body.classList.toggle("dark", darkTheme.value === "dark");
			document.body.classList.toggle("light", darkTheme.value !== "dark");
		});

		const hideNotificationCreate = () => {
			successCreate.value = false;
		};

		const updateCreateTaskId = (taskId: number) => {
			createTaskId.value = taskId;
		};

		const receiveNotification = <T extends SocketResponse<TaskComment<number>>>(msg: T) => {
			const data = msg.data;
			const currentUser = store.getters.getCurrentUser as CurrentUser | undefined;
			if (!currentUser || !currentUser.id) return;

			const getMentionId = (text: string): string[] | null => {
				const regex = /data-user="([^"]*)"/; // Регулярное выражение для поиска значения внутри кавычек
				const match = text.match(regex);

				return match && match[1] ? match[1].split("_") : null;
			};

			if (!store.getters.isNotificationGranted) return;
			if (currentUser.id === data.author_id) return;
			const storeNotification = store.getters.getNotification as StoreNotification;

			const isMessageCached =
				typeof data !== "number" &&
				storeNotification.timestamp &&
				storeNotification.message &&
				Date.now() - storeNotification.timestamp < 60000 * 5 &&
				storeNotification.message.id === data.id &&
				data.task_id === storeNotification.message.task_id;

			const isCacheMessageShouldUpdate =
				typeof data !== "number" &&
				((storeNotification.timestamp &&
					storeNotification.message &&
					Date.now() - storeNotification.timestamp > 60000 * 5) ||
					storeNotification.timestamp === null ||
					(storeNotification.timestamp &&
						storeNotification.message &&
						(storeNotification.message.id !== data.id ||
							storeNotification.message.task_id !== data.task_id)));

			if (isCacheMessageShouldUpdate) {
				store.commit("setNotification", data);
			} else if (isMessageCached) {
				return;
			}

			const user: User | null = getUserById(data.author_id);
			const bot: Bot | null = getBotById(data.author_id);
			const goToTask = (id: number, toChat = false) => {
				let route = null;
				if (toChat) {
					route = router.resolve({
						path: `/task/${data.task_id}`,
					});
				} else {
					route = router.resolve({ path: `/task/${id}` });
				}

				window.open(route.href, "_blank");
			};

			if (data.type === "comment") {
				let text = data.text;

				if (data.text.includes("<blockquote")) {
					text = data.text.split("</blockquote>")[1];
				}
				text = removeAnchorTags(removeUnnecessaryStringAt(removeSpanFromComment(text)));
				if (text.length > 40) {
					text = `${text.slice(0, 39)}...`;
				}

				const options = {
					body: `Автор ${user?.info?.name || bot?.info?.bot_name || ""} ${
						user?.info?.surname || ""
					}: ${text}`,
					requireInteraction: true,
					tag: `${data.task_id}`,
				};

				const mentionID = getMentionId(msg.data.text);
				const currentUserData = getUserById(currentUser.id);

				if (
					(msg.show_popup !== undefined && msg.show_popup) ||
					(mentionID &&
						currentUserData &&
						((mentionID[0] === "user" && parseInt(mentionID[1]) === currentUserData.id) ||
							(mentionID[0] === "department" &&
								currentUserData.department_ids.includes(parseInt(mentionID[1])))))
				) {
					const notification = new Notification(`Новый комментарий`, options);

					setTimeout(() => {
						notification.close();
					}, 7000);

					notification.addEventListener("click", () => {
						goToTask(data.task_id, true);
						notification.close();
					});
				}
			}

			if (data.info && data.type === "system") {
				switch (data.info.action) {
					case "created":
						{
							const options = {
								body: user
									? `Создатель ${
											user?.info?.name || bot?.info?.bot_name || ""
										} ${user?.info?.surname || ""}`
									: "",
								tag: `${data.task_id}`,
							};
							if (msg.show_popup !== undefined && msg.show_popup) {
								const notification = new Notification(`Создана новая задача ${data.task_id}`, options);

								setTimeout(() => {
									notification.close();
								}, 7000);

								notification.addEventListener("click", () => {
									goToTask(data.task_id);
									notification.close();
								});
							}
						}
						break;

					default:
						break;
				}
			}
		};

		const socketMessageEvent = (data: SocketResponse<TaskComment<number>>) => {
			console.debug(`[message] !!!Данные получены с сервера `);
			const msg = data;

			// Обновление счетчика задач
			if (msg.action === "update_counters") {
				store.commit("setUnreadTaskCounter", { unread_counter: msg.data });
				if (route.name === "TaskListIncoming") {
					store.commit("setAppTitle", {
						hint: store.getters.currentTaskParams,
					});
				}
			}
			socketMessage.value = msg as unknown;
			/* уведомление о задаче или комменте */
			msg.data && receiveNotification<SocketResponse<TaskComment<number>>>(msg);
		};

		const socketCloseEvent = (event: Event) => {
			const token = store.getters.getToken as string;
			// NOTIFICATION
			connectionLost.value = true;

			console.debug("Соединение закрыто");
			console.debug("[connection] Попытка возобновить соединение");

			let intervalId = setInterval(() => {
				if (isSocketConnected.value || !token) {
					// если токен есть, то делаем pulling пока соединение не восстановится
					clearInterval(intervalId);
					return;
				}
				socketEventsInit();
			}, 5000);
		};

		const handleUpdateMenuValue = (key: string) => {
			if (!isAuth.value) return;
			if (key === "logout-link") {
				store.dispatch("logout");
				store.dispatch("setAppReady", true);
				socketWorker.value && socketWorker.value.port.postMessage({ type: "closeSocket" });
				socketWorker.value && socketWorker.value.port.postMessage({ type: "logout" });
				if (chatSocket.value) chatSocket.value.close();
			}
		};

		const manageSocketEvents = (event: MessageEvent<string>) => {
			const socketData = JSON.parse(event.data) as {
				type: "error" | "close" | "connect" | "message" | "logout";
				data: string | SocketResponse<TaskComment<number>>;
			};
			switch (socketData.type) {
				case "message":
					socketMessageEvent(socketData.data as SocketResponse<TaskComment<number>>);
					break;
				case "close":
				case "error":
					if (socketData.type === "close") {
						console.debug("Соединение закрыто");
					} else {
						console.debug("Error");
						setTimeout(() => {
							connectionLost.value = false;
						}, 2000);
					}
					isSocketConnected.value = false;

					socketCloseEvent(event);
					break;
				case "connect":
					console.debug("connect");
					isSocketConnected.value = true;
					connectionLost.value = false;
					break;
				case "logout":
					handleUpdateMenuValue("logout-link");
			}
		};

		const socketMessageNoShared = async (event: MessageEvent) => {
			console.debug(`[message] !!!Данные получены с сервера `);
			const msg = JSON.parse(event.data) as SocketResponse<TaskComment<number>>;
			socketMessage.value = msg as unknown;
			/* уведомление о задаче или комменте */
			msg.data && receiveNotification<SocketResponse<TaskComment<number>>>(msg);
		};

		const socketCloseEventNoShared = (event: CloseEvent) => {
			// NOTIFICATION
			connectionLost.value = true;
			console.debug("Соединение закрыто");
			if (event.wasClean) {
				console.debug(`[close] Соединение закрыто чисто, код=${event.code} причина=${event.reason}`);
			} else {
				console.debug("[close] Соединение прервано");
			}

			console.debug("[connection] Попытка возобновить соединение");

			let intervalId = setInterval(() => {
				// если токен есть, то делаем pulling пока соединение не восстановится
				if (chatSocket.value && chatSocket.value.readyState === WebSocket.OPEN) {
					clearInterval(intervalId);
				}
				socketEventsInit();
			}, 5000);
		};

		const socketErrorEventNoShared = (error: Event) => {
			console.debug(`[error]`, error);
		};

		const socketOpenEventNoShared = () => {
			console.debug("[open] Соединение установлено");

			setTimeout(() => {
				connectionLost.value = false;
			}, 2000);
		};

		function socketEventsInit() {
			const token = store.getters.getToken as string;
			const url = import.meta.env.VITE_RADAR_SOCKET_URL as string;
			if (!token) {
				console.debug("Пользователь не авторизован");
				return;
			}

			if (window.SharedWorker) {
				if (!socketWorker.value) {
					const socketWorkerUrl = location.href.includes("http://localhost")
						? "/"
						: import.meta.env.VITE_PUBLIC_PATH;
					socketWorker.value = new SharedWorker(`${socketWorkerUrl}sharedWorker.js`, {
						type: "module",
						name: "rulseSharedWorker",
					});
					socketWorker.value && socketWorker.value.port.start();
					window.addEventListener("beforeunload", () => {
						socketWorker.value && socketWorker.value.port.postMessage({ type: "beforeunload" });
					});
					socketWorker.value.port.postMessage({
						type: "sendMessage",
						data: { token, url },
					});
					socketWorker.value && socketWorker.value.port.addEventListener("message", manageSocketEvents);
				} else {
					socketWorker.value.port.postMessage({
						type: "sendMessage",
						data: { token, url },
					});
				}
			} else {
				if (!chatSocket.value || chatSocket.value.readyState === WebSocket.CLOSED) {
					chatSocket.value = new WebSocket(`${url}/ws/events/?token=${token}`);
				}

				chatSocket.value && chatSocket.value.addEventListener("open", socketOpenEventNoShared);
				chatSocket.value && chatSocket.value.addEventListener("message", socketMessageNoShared);
				chatSocket.value && chatSocket.value.addEventListener("close", socketCloseEventNoShared);
				chatSocket.value && chatSocket.value.addEventListener("error", socketErrorEventNoShared);
			}
		}

		const requestNotification = async () => {
			if (!("Notification" in window)) return;
			if (Notification.permission === "granted") store.dispatch("setNotificationPermission", true);

			if (Notification.permission !== "denied") {
				const permission = await Notification.requestPermission();
				permission === "granted" && store.dispatch("setNotificationPermission", true);
				permission === "denied" && store.dispatch("setNotificationPermission", false);
				return;
			}
			store.dispatch("setNotificationPermission", false);
		};

		onMounted(async () => {
			socketEventsInit();
			requestNotification();
			store.commit("setIsCollapseMenu", true);
			store.commit("setIsMobile", window.innerWidth < 768);

			const user = store.getters.getCurrentUser
			if (user) {
				Sentry.setUser({id: user.id, username: user.login})
			}

			if (desktopVersion.value?.currentScreenWidth) {
				if (desktopVersion.value.currentScreenWidth !== window.innerWidth) {
					store.commit("setIsDesktopVersion", false);
				}
			}

			store.commit("setCurrentUserWidth", window.innerWidth);

			setTimeout(async () => {
				if (route.name && route.name !== "TaskList" && route.name !== "TaskListIncoming") {
					await getSettings();
				}
			});

			router.beforeEach((to, from, next) => {
				if (!isAuth.value && to.name !== "Login" && !isMobile.value) {
					next({ name: "Login" });
				} else if (
					isMobile.value &&
					to.name !== "Mobile" &&
					!isMobileVersion() &&
					!desktopVersion.value.isDesktopVersion
				) {
					next({ name: "Mobile" });
				} else {
					next();
				}
			});

			router.afterEach((to) => {
				store.commit("setAppTitle", { hint: to.name });
			});

			document.body.classList.add(darkTheme.value);

			window.addEventListener("resize", updateIsMobile);
		});

		watch(isAuth, () => {
			requestNotification();
		});

		watch(isMobile, () => {
			updateIsMobile();
		});

		onUnmounted(() => {
			socketWorker.value && socketWorker.value.port.postMessage({ type: "closeSocket" });
			socketWorker.value && socketWorker.value.port.removeEventListener("message", manageSocketEvents);

			store.commit("clearImages");

			window.removeEventListener("resize", updateIsMobile);
		});

		provide(notificationInjectKey, {
			createTaskId,
			updateCreateTaskId,
		});

		return {
			domain,
			locale: ruRU,
			dateLocale: dateRuRU,
			activeKey: ref<string | null>(null),
			collapsed: ref(true),
			menuThemeOverrides,
			themeOverrides,
			getMenuOption,
			createTaskId,
			hideNotificationCreate,
			successCreate,
			darkTheme,
			isSidebarEnabled: ref<boolean>(true),
			connectionLost,
			loginNotification: ref<boolean>(false),
			type,
			isSidebarVisible: ref<boolean>(true),
			socketMessage,
			socketEventsInit,
			socketWorker,
			socketMessageEvent,
			isAuth,
			isSocketConnected,
			handleUpdateMenuValue,
			chatSocket,
			isMobile,
			desktopVersion,
			isMobileVersion,
		};
	},
	beforeCreate() {
		this.$store.dispatch("changeForwardPathName", window.location.pathname.replace("/task-antenna/", "/"));
	},
	async created() {
		this.$store.dispatch("setAppReady", false);
		await this.initApp();
		this.$store.dispatch("setAppReady", true);
	},
	computed: {
		appReady() {
			return this.$store.getters.isAppReady;
		},
		user() {
			return this.$store.getters.getCurrentUserInfo;
		},
	},
	methods: {
		async initApp() {
			if (!String(this.$store.getters.getForwardPathName).includes("mobile")) {
				this.$store.commit("setCurrentMobileLocation", this.$store.getters.getForwardPathName);
			}
			if (this.isMobile && !this.desktopVersion.isDesktopVersion && !this.isMobileVersion()) {
				this.$router.push({ name: "Mobile" });
			} else if (!this.isAuth) {
				this.$router.push({ name: "Login" });
			} else if (this.appReady === false) {
				this.$store.dispatch("changeTasks", []);
				this.$store.dispatch("setTaskEmpty");
				this.$store.dispatch("changeComments", []);
				await getUsersDepartments();
				await getUnreadTaskCounter();
				const currentUser = this.$store.getters.getCurrentUser as CurrentUser | undefined;
				if (!currentUser || !currentUser.id) {
					return;
				}
				const user = await getUserInfoById(currentUser.id);
				this.$store.dispatch("setCurrentUserInfo", user);
				this.$store.dispatch("setForms", await getForms());
				if (this.$route.name !== "Task" && this.$route.name !== "TaskListIncoming") {
					this.$store.commit("setAppTitle", { hint: this.$route.name });
				}
				this.checkCatalogTimestamp();
				if (this.$route.name === "Home") {
					this.$router.push({ name: "TaskListIncoming" });
				}
			}

			if (this.isAuth && this.$store.getters.getUsers.length === 0) {
				await getUsersDepartments();
			}
		},
		disableSidebar(value: boolean) {
			this.isSidebarEnabled = value;
		},
		checkCatalogTimestamp() {
			const catalogs = this.$store.getters.getCatalogs as CatalogDataTypeWithTime[];
			const notOverdueCatalogs = catalogs.filter((catalog) => {
				if (catalog && catalog.timestamp) {
					return catalog.timestamp && Date.now() - catalog.timestamp < 60000 * 60;
				}
			});
			this.$store.commit("setCatalogs", notOverdueCatalogs);
		},
	},
	watch: {
		$route(to, from) {
			this.isSidebarVisible = !(to.name === "Login" || to.name === "FormConstructor");

			if (to.name === "FormConstructor") {
				this.isSidebarEnabled = false;
			} else if (["Form", "Task", "TaskIncoming"].includes(to.name)) {
				this.$store.dispatch("changeIsError", false);
				this.$store.dispatch("changeComments", []);
			} else if (from.name === "Login") {
				if (!this.chatSocket || (this.chatSocket as WebSocket).readyState === WebSocket.CLOSED) {
					this.chatSocket = new WebSocket(`${this.domain}/ws/events/?token=${this.$store.getters.getToken}`);
					this.socketEventsInit();

					this.loginNotification = true;

					setTimeout(() => {
						this.loginNotification = false;
					}, 2500);
				}
			}
			if (from.name === "FormConstructor") {
				this.isSidebarEnabled = true;
			}

			if (
				((from.name === "TaskListIncoming" || from.name === "TaskList") &&
					(to.name === "TaskIncoming" || to.name === "Task")) ||
				((to.name === "TaskListIncoming" || to.name === "TaskList") &&
					(from.name === "TaskIncoming" || from.name === "Task")) ||
				(!from.name && to.name === "TaskList") ||
				(!from.name && to.name === "TaskListIncoming")
			)
				return;
			// очищаем параметры в списке задач
			this.$store.dispatch("clearQueryParams");
		},
		collapsed() {
			this.$store.commit("setIsCollapseMenu", this.collapsed);
		},
		async isAuth() {
			await this.initApp();
			// Возбновляем работу сокетов
			this.socketEventsInit();
		},
		appReady() {
			if (this.appReady === false) {
				document.documentElement.style.overflow = "hidden";
			} else {
				document.documentElement.style.overflow = "";
			}
		},
	},
});
</script>
<style>
@import "@/shared/assets/style/base/theme.css";
@import "@/shared/assets/style/base/style.css";
@import "@/shared/assets/style/base/globalStyle.css";
@import "@/shared/assets/style/components/input.css";
@import "@/shared/assets/style/base/naiveReset.css";
@import "@/shared/assets/style/components/buttons.css";

.app__class {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: var(--text-color);
	background: #f5f6fa;
	height: 100vh;
	width: 100%;
	display: flex;
}

table {
	margin-right: auto;
}

.n-menu-item-content--disabled {
	opacity: 1 !important;
	cursor: default !important;
}

.n-layout .n-layout-scroll-container {
	width: 100%;

	@media (max-width: 768px) {
		flex-flow: column !important;
	}
}

.main-container {
	background-color: #ffffff;
	padding: 20px 24px;
	box-shadow: 0 1px 3px #00000014;
	border-radius: 8px;
}

.h-title {
	color: var(--text-color);
	font: 600 24px/1.5 inter;
}

.dark .main-container {
	background-color: var(--card-bg);
}

.content__container {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding: 32px 24px 24px 24px;

	@media (max-width: 768px) {
		padding: 12px 16px 6px 16px;
	}
}

.n-input,
.n-select {
	text-align: left;
}

.clickable {
	cursor: pointer;
}

.first-load {
	top: 25%;
	left: 25%;
	width: 50%;
	height: 50%;
	position: fixed;
	transform-origin: 0% 50%;
	overflow: hidden;
	z-index: 6;
}

.overlay {
	background-color: var(--card-bg);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 11;
}

.dark .overlay {
	background-color: var(--dark-bg-500);
}

@keyframes spin {
	from {
		transform: rotate(360deg) scale(0.5);
	}

	to {
		transform: rotate(0deg) scale(3);
	}
}

@keyframes wiggle {
	0%,
	7% {
		transform: rotateZ(0);
	}

	15% {
		transform: rotateZ(-6deg);
	}

	20% {
		transform: rotateZ(6deg);
	}

	25% {
		transform: rotateZ(-6deg);
	}

	30% {
		transform: rotateZ(6deg);
	}

	35% {
		transform: rotateZ(-6deg);
	}

	40%,
	100% {
		transform: rotateZ(0);
	}
}

@keyframes pulse {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.06);
	}
	100% {
		transform: scale(1);
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
</style>
